import request from "@/utils/request";

/**
 * 组员-获取客户列表
 *
 */
export function getMyClientPage(data) {
  return request({
    url: "/User/ClientInfo/MyClient",
    method: "post",
    data: data,
  });
}

/**
 * 企业老板-获取所有客户列表
 *
 */
export function getCorporationClientPage(data) {
  return request({
    url: "/User/ClientInfo/CorporationClient",
    method: "post",
    data: data,
  });
}

/**
 * 企业负责人-获取所有客户列表
 *
 */
export function getAdminClientPage(data) {
  return request({
    url: "/User/ClientInfo/AdminClient",
    method: "post",
    data: data,
  });
}

/**
 * 更新客户
 *
 */
export function getUpdateClient(data) {
  return request({
    url: "/User/ClientInfo/Update",
    method: "post",
    data: data,
  });
}

/**
 * 创建客户
 *
 */
export function getCreateClient(data) {
  return request({
    url: "/User/ClientInfo/Create",
    method: "post",
    data: data,
  });
}
